export default "__VITE_ASSET__06ba30aa__"